import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router'
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { fetchOrders } from '../../actions'
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import MenuIcon from 'material-ui/svg-icons/navigation/menu';
import TextField from 'material-ui/TextField'
import SideNavBar from './SideNavBar';
import { white } from 'material-ui/styles/colors';

const propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  menuToggle: PropTypes.func.isRequired,
};

const styles = {
  inputStyle: {
    marginRight: '1%',
    position: 'absolute',
    top: 0,
    zIndex: '2999',
    backgroundColor: white,
    padding: '0 1em',
  },
}

class Header extends Component { // eslint-disable-line react/prefer-stateless-function
  constructor() {
    super();
    this.state = {
      moveHeaderTitle: {
        paddingLeft: '25px',
      },
    }
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  handleLogout(e) {
    e.preventDefault();
    this.props.logout();
    browserHistory.push('/');
  }
  handleMenu(e) {
    e.preventDefault();
    this.props.menuToggle();
  }

  handleSearchChange (e) {
    if (!e.target.value || e.target.value.length <= 3) return;
    const { dispatch, router } = this.props
    let query = { search: e.target.value, page: 1 }
    router.push({ pathname: '/orders', query })
    dispatch(fetchOrders(query))
  }

  render() {
    const { isAuthenticated } = this.props;
    let iconLeft;
    if (!!isAuthenticated) {
      iconLeft = <IconButton onClick={this.handleMenu}><MenuIcon /></IconButton>;
    } else {
      iconLeft = <i></i>;
    }
    return (
      <div style={{ position: 'fixed', width: '100%', top: '0', zIndex: 99 }}>
        <AppBar
          title="FOCUS Admin"
          iconElementLeft={iconLeft}
          iconElementRight={(isAuthenticated) ? <IconMenu
            iconButtonElement={<IconButton><MoreVertIcon /></IconButton>}
            targetOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          >
          <MenuItem onClick={this.handleLogout}>Logout</MenuItem>
          </IconMenu> : <i></i>}
          />
          <TextField
              inputStyle={styles.inputStyle}
              style={{ position: 'absolute', top: '8px', right: '60px' }}
              id='topSearch'
              onChange={this.handleSearchChange}
            />
          <SideNavBar menuToggle={this.props.menuToggle} />
      </div>
    );
  }
}

Header.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

Header.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
  };
}

export default withRouter(connect(mapStateToProps)(Header))



// WEBPACK FOOTER //
// ./src/components/home/Header.js